import { render, staticRenderFns } from "./LibHeaderAccount.vue?vue&type=template&id=4a871eae&scoped=true"
import script from "./LibHeaderAccount.vue?vue&type=script&lang=js"
export * from "./LibHeaderAccount.vue?vue&type=script&lang=js"
import style0 from "./LibHeaderAccount.vue?vue&type=style&index=0&id=4a871eae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a871eae",
  null
  
)

export default component.exports